import { render, staticRenderFns } from "./AanvullendeVragenDetails.vue?vue&type=template&id=0dd1b282"
import script from "./AanvullendeVragenDetails.vue?vue&type=script&lang=ts"
export * from "./AanvullendeVragenDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports